import { TableRow, TableCell, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StandardTable from '../ui/StandardTable';
import TooltipIconButton from '../ui/TooltipIconButton';

const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v ?? 0);
const fmtDate = (iso) => new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo'
}).format(new Date(iso));

const columns = [
  { id: 'attendedAt', label: 'Data' },
  { id: 'clientName', label: 'Cliente' },
  { id: 'serviceName', label: 'Serviço' },
  { id: 'professionalName', label: 'Profissional' },
  { id: 'placeName', label: 'Local' },
  { id: 'grossValue', label: 'Bruto', align: 'right' },
  { id: 'netValue', label: 'Líquido', align: 'right' },
  { id: 'actions', label: 'Ações', align: 'right', width: 80 },
];

export default function FinanceTable({ response, loading, onDetailsClick }) {
  const items = response?.items ?? [];

  return (
    <StandardTable
      columns={columns}
      loading={loading}
      isEmpty={!loading && items.length === 0}
      emptyMessage="Nenhum atendimento realizado no período"
    >
      {items.map((it) => {
        const hasDelta = it.grossValue != null && it.netValue != null && it.grossValue !== it.netValue;
        return (
          <TableRow key={it.id} hover>
            <TableCell>{fmtDate(it.attendedAt)}</TableCell>
            <TableCell>{it.clientName}</TableCell>
            <TableCell>{it.serviceName}</TableCell>
            <TableCell>{it.professionalName}</TableCell>
            <TableCell>{it.placeName}</TableCell>
            <TableCell align="right">
              <Typography
                variant="body2"
                sx={{ textDecoration: hasDelta ? 'line-through' : 'none', color: hasDelta ? 'text.secondary' : 'text.primary' }}
              >
                {fmt(it.grossValue)}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="body2" fontWeight={600}>{fmt(it.netValue)}</Typography>
            </TableCell>
            <TableCell align="right">
              <TooltipIconButton title="Ver detalhes" icon={<VisibilityIcon />} onClick={() => onDetailsClick(it)} />
            </TableCell>
          </TableRow>
        );
      })}
      {items.length > 0 && (
        <TableRow>
          <TableCell colSpan={5} align="right"><strong>Total:</strong></TableCell>
          <TableCell align="right"><strong>{fmt(response.totalGross)}</strong></TableCell>
          <TableCell align="right"><strong>{fmt(response.totalNet)}</strong></TableCell>
          <TableCell />
        </TableRow>
      )}
    </StandardTable>
  );
}
